const actions = {
  LIST_MEMBRESIAS_PACIENTE: 'LIST_MEMBRESIAS_PACIENTE',
  LIST_MEMBRECIAS_SELECTBOX: 'LIST_MEMBRECIAS_SELECTBOX',
  CREATE_MEMBRESIA_PACIENTE: 'CREATE_MEMBRESIA_PACIENTE',
  READ_MEMBRESIA_PACIENTE: 'READ_MEMBRESIA_PACIENTE',
 

  membresiasList: data => {     
    return {
      type: actions.LIST_MEMBRESIAS_PACIENTE,
      data,
    };
  },

  membresiasListSelectBox: data => {
    return {
      type: actions.LIST_MEMBRECIAS_SELECTBOX,
      data,
    };
  },

  membresiaCreate: data => {
    return {
      type: actions.CREATE_MEMBRESIA_PACIENTE,
      data,
    };
  },

  membresiaRead: data => {
    return {
      type: actions.READ_MEMBRESIA_PACIENTE,
      data,
    };
  },

};

export default actions;
